"use strict";

import {find, closest, on} from "../libs/@elements/dom-utils";
import {onFind} from "../libs/@elements/init-modules-in-scope";

export function init () {

    onFind('.js-collapsing-radio__input', function (item) {
        on('change', function(event) {

            let $collapseParent = closest('.js-collapsing-radio', item);
            let $collapseArea = find('.js-collapsing-radio__add', $collapseParent);

            if (item.checked === true){
                $collapseArea.removeAttribute('hidden');
            } else {
                $collapseArea.setAttribute('hidden',true);
            }

        }, item);
    });

}